import React, {useEffect, useState} from 'react';
import {watchRollRequest} from '../rollRequestRepository';
import {findRequestRoll, getRequestLabel} from '../rollRequest';
import {vtmT, currentLanguage} from '../i18n';
import {outcomeText, outcomeTone} from './VtmDice';

/** Écoute le jet demandé par le MJ pour une campagne (null s'il n'y en a pas). */
export const useRollRequest = (campaignUid) => {
  const [request, setRequest] = useState(null);
  useEffect(() => (campaignUid ? watchRollRequest(campaignUid, setRequest) : undefined), [campaignUid]);
  return request;
};

const requestTitle = (request) => getRequestLabel(request, currentLanguage()) || vtmT('frenzyCheck');

/** « diff. 3 · caché » */
const requestMeta = (request) => [
  request.difficulty !== null && vtmT('rollRequestDifficulty', {value: request.difficulty}),
  request.hidden && vtmT('rollRequestHidden'),
].filter(Boolean).join(' · ');

/** Côté joueur : la demande du MJ, au-dessus des actions, avec un bouton pour lancer. */
export const VtmRollRequestBanner = ({request, onRoll}) => {
  const meta = requestMeta(request);
  return (
    <section className="vtmRequestBanner" aria-live="polite">
      <span className="vtmRequestEyebrow">{vtmT('rollRequestFromDm')}</span>
      <div className="vtmRequestLine">
        <span>
          <strong className="vtmRequestLabel">{requestTitle(request)}</strong>
          {meta && <span className="vtmRequestMeta"> · {meta}</span>}
        </span>
        <button type="button" className="vtmButton primary" onClick={onRoll}>{vtmT('rollRequestAnswer')}</button>
      </div>
    </section>
  );
};

/** Côté MJ : qui a lancé, avec quel résultat, et de quoi clore la demande. */
export const VtmRollRequestStatus = ({request, rolls, characters, onClose}) => {
  const rows = request.targets.map(characterUid => ({
    characterUid,
    name: characters.find(character => character.uid === characterUid)?.name || vtmT('newCharacter'),
    roll: findRequestRoll(request, characterUid, rolls),
  }));
  const meta = requestMeta(request);
  return (
    <section className="vtmRequestBanner dm" aria-label={vtmT('rollRequestCurrent')}>
      <span className="vtmRequestEyebrow">{vtmT('rollRequestCurrent')}</span>
      <p className="vtmRequestLine">
        <span>
          <strong className="vtmRequestLabel">{requestTitle(request)}</strong>
          {meta && <span className="vtmRequestMeta"> · {meta}</span>}
        </span>
      </p>
      <ul className="vtmRequestTargets">
        {rows.map(({characterUid, name, roll}) => (
          <li key={characterUid} className="vtmRequestTarget">
            <span>{name}</span>
            {roll ? (
              <span className={`vtmRequestResult ${outcomeTone(roll.outcome)}`}>
                {outcomeText(roll)}
                {roll.outcome && ` · ${roll.successes}`}
              </span>
            ) : (
              <span className="vtmRequestResult waiting">{vtmT('rollRequestWaiting')}</span>
            )}
          </li>
        ))}
      </ul>
      {rows.every(row => row.roll) && <p className="vtmMutedInline">{vtmT('rollRequestAllDone')}</p>}
      <button type="button" className="vtmTextButton" onClick={onClose}>{vtmT('rollRequestClose')}</button>
    </section>
  );
};
